export const CREATE_SURVEY_RESPONSE_REQUEST = 'CREATE_SURVEY_RESPONSE_REQUEST';
export const FETCH_SURVEY_PREVIEW_BY_UUID = 'FETCH_SURVEY_PREVIEW_BY_UUID';
export const SET_SPINNER_LOADING = 'SET_SPINNER_LOADING';
export const SET_LOADING_REQUEST = 'SET_LOADING_REQUEST';
export const SET_NEW_VERSION = 'SET_NEW_VERSION';
export const SET_COMPLETED_COUNT = 'SET_COMPLETED_COUNT';
export const SET_SURVEY_USER_VARIABLES = 'SET_SURVEY_USER_VARIABLES';
export const SET_SESSION_TOKEN = 'SET_SESSION_TOKEN';
